import React, { Component } from "react";
import { connect } from "react-redux";
import Graphics from 'components/solution/Graphics';

import './Solution.scss'
import { solutionOpen } from '../../actions';

import { withTranslation } from 'react-i18next'

class Solution extends Component {

    toggleClosed = () =>{
        this.props.solutionOpen(
            {
                id:this.props.id,
                open: !this.props.open
            }
        );
    }

    render() {
        return (
          <ul>
            <li
                onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.toggleClosed(e)} }
                id={'Solution_'+this.props.id} tabIndex={0}
                className={'Solution dropTarget'+((this.props.open)?' open':'')}>
                <p aria-hidden="true" className="label">{this.props.t(this.props.type)}</p>
                <Graphics id={this.props.id} />
            </li>
          </ul>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    //Using solutions array because individual elements
    //don't populate in time to map to props
    return {
        id: ownProps.id,
        open: state.solution.solutions[ownProps.id-1].open,
        type: state.solution.solutions[ownProps.id-1].type,
        description:null
    };
};

export default connect(mapStateToProps, {solutionOpen
})(withTranslation()(Solution));
